
import { Component, Vue, Watch } from "vue-property-decorator";
import { RankingList, StatisticalData, deviceStatus } from "@/views/components";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import Scan2 from "@/views/components/Scan/Scan2.vue";
import config from "./config";
import Form1 from "./Form1.vue";
import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";
import {
  ModeAddType,
  ApiQueryType,
  OpCodeEnum,
  UploadStateEnum,
  ModeType,
  ScanSysType,
  SendDataType,
  ReceiveDataType,
  ErrorCode,
} from "@/common/glboalconstant";
import { LogHelper } from "@/common/LogHelper";
import { playLayerVioce, FloorVoiceInit } from "@/common/voiceLayer";
import dayjs from "dayjs";
import {
  checkCode,
  checkCodesAndType,
  modeNew,
  checklineFrequencys, cloudPress,
} from "@/api/service";
import {
  playFailSound,
  playSuccessSound,
  playWantedPackSound,
  playWarnSound,
} from "@/common/voiceTip";
import { DeviceItems2Module } from "@/store/modules/store_deviceitems2";
import TipMessages from "@/views/scanforroughsorting/TipMessages.vue";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "scanforroughsorting",
  components: {
    TipMessages,
    deviceStatus,
    StatisticalData,
    YtoTable,
    Form1,
    Scan2,
    DeviceItems2,
  },
})
export default class extends Vue {
  public loginData: any = {};
  public globalConfig: any = {};
  public systemConfig: any = {};

  mounted() {
    debugger;
    console.log('start loaded')

    //初始化统计数据栏目内显示的数据
    this.statisticalList = [{ label: "总扫描数", value: "0", combine: "1" }];

    try {
      //注册设备状态回调函数
      this.globalConfig = SystemConfigModule.globalData;
      this.systemConfig = SystemConfigModule.systemData;
      this.loginData = SystemConfigModule.loginData;

      FloorVoiceInit();
    } catch (error) {
      console.log("粗分扫描界面:注册回调函数异常" + error);
    }

    //注册相机回调条码事件
    if (typeof obj_CodeReader_Core !== "undefined") {
      obj_CodeReader_Core.registerJavaScriptCallback(
        "CodeReaderSetPackageData",
        (value) => {
          LogHelper.WriteLog(
            dayjs().format("YYYY-MM-DD HH:mm:ss SSS") + "得到快手条码:"+value
          );
          let data = JSON.parse(value);
          this.RoughSortingUpload(data.CodeInfo);
        }
      );
      console.log('CodeReaderSetPackageData注册成功');
    }


    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
    console.log('loaded')
    if (typeof obj_ScanForRoughSorting !== "undefined")
    {
      obj_ScanForRoughSorting.vueLoaded();
    }
  }

  //DWS设置相机状态
  private SetCameraState(strCameraState) {
    debugger;
    let items = this.RefreshState(strCameraState);
    DeviceItems2Module.SetDeviceItemsState(items);
    return;
  }

  //DWS刷新设备状态信息
  private RefreshState(camera_State) {
    debugger;
    let result = [];
    for (let i = 1; i <= camera_State.cameraState.camList.length; i++) {
      let _info =
        "" +
        "设备" +
        i.toString() +
        "-" +
        "设备状态:" +
        camera_State.cameraState.camList[i - 1].camStatus +
        "-" +
        "设备模式:" +
        this.IsNullorEmptyorUndefined(
          camera_State.cameraState.camList[i - 1].camModel
        )
          ? ""
          : camera_State.cameraState.camList[i - 1].camModel +
            "-" +
            //$"是否有值:是-" +
            "设备Mac:" +
            camera_State.cameraState.camList[i - 1].camMac;

      result.push({
        title: _info,
        name: "设备" + i,
        status:
          camera_State.cameraState.camList[i - 1].camStatus == "1"
            ? "true"
            : "false",
      });
    }

    return result;
  }
  public SetErrorInfo(stErrorInfo) {
    LogHelper.WriteLog(
      "ScanGetOff_HKDeviceErrorInfo: " + JSON.stringify(stErrorInfo)
    );
    this.errormessage = stErrorInfo.ErrorString;
  }

  //业务逻辑处理
  private RoughSortingUpload(code)
  {
    let datetime = dayjs();
    try {
      let createTime = datetime.format("YYYY-MM-DD HH:mm:ss.SSS");
      let tips = "";
      let stateMsg = "未上传";
      let daTouBi = "", destOrgCode = "",layer = "";
      let signsure = obj_HttpRequest_Core.getSignature("8608", createTime);
      let _request = {
        mty: "8608",
        signature: signsure,//登录时需要获取的签名
        createTime: createTime,
        createUserCode: this.loginData.userCode,
        createUserName: this.loginData.userName,
        createOrgCode: this.loginData.orgCode,
        createOrgName: this.loginData.orgName,
        channel: "CV-PC",
        deviceNo: this.globalConfig.LocalIPv4,
        deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
        waybillNo: code,
        autoMode: "1",
        weight: "",
        cuFenType:"2",
        optFlag:"",
        inOutFlag:""
      };
      let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
      daTouBi = stReturnStr?.data.threeCode;
      destOrgCode = stReturnStr?.data.destOrgCode;
      layer = stReturnStr?.data.soundFloorNo;
      if(stReturnStr.data.soundFloorNo != null && stReturnStr.data.soundFloorNo != "")
      {
        this.errormessage = stReturnStr.data.soundFloorNo + "层";
      }
      playLayerVioce(stReturnStr.data.soundFloorNo);
      if (stReturnStr?.code == "000")
      {
        stateMsg = "上传成功";
        try {
          obj_System_Core.refreshLoaclTime(
            stReturnStr?.data?.serverTime.toString()
          );
        } catch (error) {
          LogHelper.Error(error);
        }
      }
      else
      {
        stateMsg = "上传失败";
        tips = stReturnStr?.msg;
      }
      this.InsertDataToList(code,daTouBi,destOrgCode,layer,stateMsg,tips,datetime);
    }
    catch (ex) {
      console.log(ex.toString());
    }
  }

  public setPackageData(stPackageData) {
    LogHelper.WriteLog("ScanGetOff_GetHKInfo;" + JSON.stringify(stPackageData));
    //待处理逻辑
    return true;
  }
  private nTotalScanNum = 0;

  //插入表格
  private InsertDataToList(strcode, daTouBi, destOrgCode, layer, stateMsg, tips, datetime) {
    this.nTotalScanNum++;
    this.statisticalList[0].value = this.nTotalScanNum.toString();
    var data: any = {
      strCode: strcode,
      ThreeCode:daTouBi,
      destOrgCode:destOrgCode,
      layerNum:layer,
      ScanTime: datetime.format("YYYY-MM-DD HH:mm:ss"),
      state: stateMsg,
      Info: tips,
      index: this.index,
    };
    this.index++;
    this.showList.unshift(data);
    while (this.showList.length > 50) {
      this.showList.pop();
    }
    return this.index;
  }

  //新异常走件接口，add by klm 20220420
  public NewAbnormalMovingPartUpload(
    strCode,
    strInfo,
    strIoTypeName = null,
    exceptionCode = null) {
    try {
      let ioType = null;
      let datetimeNow = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
      let signsure = obj_HttpRequest_Core.getSignature("8606", datetimeNow);

      let _request = {
        mty: "8606",
        signature: signsure,//登录时需要获取的签名
        createTime: datetimeNow,
        waybillNo: strCode,
        containerNo: "",//容器号,非必填
        deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
        deviceNo: this.globalConfig.LocalIPv4,//大写,用冒号分隔，必填
        errorCode: exceptionCode,//异常码，必填
        errorMsg: strInfo,//异常信息，必填
        opCode: "335",//操作码，非必填
        ioType: ioType,//收发类型，非必填
        nextOrgCode: "",//下一网点，非必填
        weight: "",//重量，非必填
        createUserCode: this.loginData.userCode,
        extend1: "",
        extend2: "",
        extend3: ""
      };
      let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
      if (stReturnStr?.code == "000") {
        LogHelper.WriteLog("新异常走件方法上传成功");
      } else {
        LogHelper.WriteLog("新异常走件上传失败,返回异常码：" + stReturnStr?.code + "异常信息：" + stReturnStr?.msg);
      }
    } catch (ex) {
      LogHelper.WriteLog("新异常走件接口调用异常" + ex);
    }
  }


  private sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }
  private currentRowChanged(element) {
    //ScanforSixScanModule.setTrueThingCode(element.strCode);
  }
  //字符串为null、空、未定义判断
  private IsNullorEmptyorUndefined(data) {
    if (data == null || data == undefined || data == "") {
      return true;
    } else {
      return false;
    }
  }
  //获得焦点，选中文本
  private getInputFocus(event): void {
    event.currentTarget.select();
  }
  //更新设备状态数据
  public getdevicestatecallback(datas): void {
    console.log("设备状态");
    console.log(datas);
    this.deviceItems = [];
    this.deviceItems = datas;
    console.log(this.deviceItems);
  }
  public index = 1;

  //错误消息回调显示方法
  public errormsgcallback(data) {
    this.errormessage = data;
  }
  public msg = "";
  private config = config;
  private statisticalList = [];
  public currentrow = null;
  public showList = [];
  public ytoCode = "";
  private ytocodeget() {
    try {
      debugger;
      var scanAreaContent = this.ytoCode.toUpperCase().toUpperCase().trim();
      if (scanAreaContent == "") {
        try {
          playFailSound();
          this.errormessage = "输入为空";
          return;
        } catch (Exception) {
          this.errormessage = "输入为空,警告提示音不存在";
          return;
        }
      }

      this.errormessage = "";
      //条码校验
      let temps = [];
      temps.push(scanAreaContent);
      var rgStr = checkCodesAndType(
        temps,
        "335"
      );

      var rg = JSON.parse(rgStr);
      if (rg.ResultCode != "200") {
        this.errormessage = rg.Info;
        if (rg.ResultCode != "407") {
          this.$nextTick(() => {
            this.NewAbnormalMovingPartUpload(
              scanAreaContent,
              rg.Info,
              null,
              "100"
            );
          });
        }
        return;
      }
      else
      {
        if (rg.Type == ApiQueryType.strWayBillCode)
        {
          this.RoughSortingUpload(scanAreaContent);
        }
        else
        {
          this.errormessage="运单不合法";
          this.$nextTick(() => {
            this.NewAbnormalMovingPartUpload(
              scanAreaContent,
              "运单不合法",
              null,
              "100"
            );
          });
        }
      }
    }
    catch (e) {
      console.log(e.toString());
    }
  }


  public selectElementContents(el) {
    console.log("|FUNC|selectElementContents");
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  private deviceItems: deviceItem[] = [];
  private errormessage = "";

}
